import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Footer({ settings }) {
  return (
    <footer data-testid="site-footer" className="bg-[#0a0a0a] text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="font-serif text-xl text-white">
              {settings?.business_name || "PennyMacs"}
            </h3>
            <div className="gold-line mt-3 mb-4" />
            <p className="text-sm text-[#9a9a9a] leading-relaxed font-light">
              Certified pre-owned MacBooks. Simple pricing. Real trust.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[11px] font-semibold text-[#b5954a] uppercase tracking-[0.2em] mb-5">
              Shop
            </h4>
            <div className="space-y-3">
              <Link to="/shop" data-testid="footer-link-shop" className="block text-sm text-[#9a9a9a] hover:text-white transition-colors font-light">
                All MacBooks
              </Link>
              <Link to="/shop?category=air" data-testid="footer-link-air" className="block text-sm text-[#9a9a9a] hover:text-white transition-colors font-light">
                MacBook Air
              </Link>
              <Link to="/shop?category=pro" data-testid="footer-link-pro" className="block text-sm text-[#9a9a9a] hover:text-white transition-colors font-light">
                MacBook Pro
              </Link>
              <Link to="/warranty" data-testid="footer-link-warranty" className="block text-sm text-[#9a9a9a] hover:text-white transition-colors font-light">
                Warranty Info
              </Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-[11px] font-semibold text-[#b5954a] uppercase tracking-[0.2em] mb-5">
              Legal
            </h4>
            <div className="space-y-3">
              <Link to="/privacy" data-testid="footer-link-privacy" className="block text-sm text-[#9a9a9a] hover:text-white transition-colors font-light">
                Privacy Policy
              </Link>
              <Link to="/terms" data-testid="footer-link-terms" className="block text-sm text-[#9a9a9a] hover:text-white transition-colors font-light">
                Terms of Service
              </Link>
              <Link to="/return-policy" data-testid="footer-link-returns" className="block text-sm text-[#9a9a9a] hover:text-white transition-colors font-light">
                Return Policy
              </Link>
              <Link to="/contact" data-testid="footer-link-contact" className="block text-sm text-[#9a9a9a] hover:text-white transition-colors font-light">
                Contact Us
              </Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[11px] font-semibold text-[#b5954a] uppercase tracking-[0.2em] mb-5">
              Contact
            </h4>
            <div className="space-y-3">
              {settings?.phone && (
                <a
                  href={`tel:${settings.phone}`}
                  data-testid="footer-phone"
                  className="flex items-center gap-2 text-sm text-[#9a9a9a] hover:text-white transition-colors font-light"
                >
                  <Phone className="w-3.5 h-3.5 text-[#b5954a]" />
                  {settings.phone}
                </a>
              )}
              {settings?.email && (
                <a
                  href={`mailto:${settings.email}`}
                  data-testid="footer-email"
                  className="flex items-center gap-2 text-sm text-[#9a9a9a] hover:text-white transition-colors font-light"
                >
                  <Mail className="w-3.5 h-3.5 text-[#b5954a]" />
                  {settings.email}
                </a>
              )}
              {settings?.address && (
                <div
                  data-testid="footer-address"
                  className="flex items-start gap-2 text-sm text-[#9a9a9a] font-light"
                >
                  <MapPin className="w-3.5 h-3.5 text-[#b5954a] mt-0.5 shrink-0" />
                  {settings.address}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#6b6b6b]">
            &copy; {new Date().getFullYear()} {settings?.business_name || "PennyMacs"}. All rights reserved.
          </p>
          <p className="text-xs text-[#6b6b6b]">
            {settings?.hours && `Hours: ${settings.hours}`}
          </p>
        </div>
      </div>
    </footer>
  );
}
